import { useState, useRef, useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';
import { InputDataItem } from '@/types';
import InputContainer from './InputContainer';
import InputButtons from './InputButtons';
import inputConfigMap from "../inputTypeConfig";

type ConfigureProps = {
    inputData: any; // Adjust this type based on the actual structure of inputData
    setInputData: any;
    className: string;
};

const Template: React.FC<ConfigureProps> = ({ inputData, setInputData, className }) => {
    const [inputButtons, setInputButtons] = useState([
        { key: 'text', value: 'Text Input' },
        { key: 'long_text', value: 'Long Text Input' },
        { key: 'options', value: 'Options dropdown' },
        { key: 'number', value: 'Numeric input' },
        { key: 'checkbox', value: 'Checkbox' },
        { key: 'list', value: 'Text list' },
        { key: 'json', value: 'JSON' },
        { key: 'json_list', value: 'List of JSONs' },
        { key: 'file_text', value: 'File to text' },
        { key: 'file_url', value: 'File to URL' },
        { key: 'file_urls', value: 'Multiple Files to URLs' },
        { key: 'table', value: 'Table' },
        { key: 'api_key', value: 'API key input' },
        { key: 'oauth_account_id', value: 'Oauth account' },
    ]);
    

    

    const addBlankData = (label: string, type: string) => {
        setInputData((prevInputData) => [
            ...prevInputData,
            {
                id: uuidv4(),
                title: '',
                type: type,
                required: true,
                description: '',
                testValue: '',
                inputText: label,
                labelText: label
            }
        ]);
    };

    const removeInputData = (id: string) => {
        setInputData((prevInputData) =>
            prevInputData.filter((item) => item.id !== id)
        );
    };

    const handleInputChange = (id: string, newValue: any) => {
        setInputData(prevInputData =>
            prevInputData.map(item =>
                item.id === id ? { ...item, testValue: newValue } : item
            )
        );
    };

    const handleToggle = (id: string) => {
        setInputData(prevInputData =>
            prevInputData.map(item =>
                item.id === id ? { ...item, required: !item?.required } : item
            )
        );
    };

    const onChangeLabel = (id: string, name: any, newValue: any) => {
        setInputData(prevInputData =>
            prevInputData.map(item =>
                item.id === id ? { ...item, [name]: newValue } : item
            )
        );
    };

    return (
       <>
       <InputButtons
                labels={inputButtons}
                onAdd={addBlankData}
            />
            
       <InputContainer
                inputData={inputData}
                onChange={handleInputChange}
                onRemove={removeInputData}
                inputConfigMap={inputConfigMap}
                onChangeLabel={onChangeLabel}
                className={className}
                handleToggle={handleToggle}
            />
            
        </>
    );
};

export default Template;
